import cities from '../cities.js';
import { selectize } from 'selectize';

$('.js-custom-select select').each(function ( i , el ) {
  $(el).selectize()
})

$('.js-custom-search-select select').each(function ( i , el ) {
  const $container = $(el).parents('.js-custom-search-select');
  $(el).selectize({
    allowEmptyOption: true
  })
  if ( $container.is('[data-show-init-value]') ) return;
  $(this)[0].selectize.clear(true);
})

// поиск на главной возле карты
$('.js-main-search-field').on('input', e => {
  const $container = $(e.target).parents('.js-main-search')
  e.target.value.length >= 3 ? $container.addClass('active') : $container.removeClass('active')
})

$(document).on('click', e => {
  if ( !$('.js-main-search-field').is(e.target) && $('.js-main-search-field').has(e.target).length === 0 ) {
    $('.js-main-search').removeClass('active')
  }
})

// поиск в шапке

$('.js-navbar-search-button').on('click', e => {
  $(e.currentTarget).toggleClass('active')
  $('.js-navbar-search').fadeToggle(300)
})

$('.js-navbar-search-field input').on('input', e => {
  const $container = $(e.target).parents('.js-navbar-search')
  e.target.value.length >= 3 ? $container.addClass('active') : $container.removeClass('active')
})

$(document).on('click', e => {
  if ( !$('.js-navbar-search').is(e.target) && $('.js-navbar-search').has(e.target).length === 0 && !$('.js-navbar-search-button').is(e.target) && $('.js-navbar-search-button').has(e.target).length === 0 ) {
    $('.js-navbar-search').removeClass('active')
    $('.js-navbar-search').fadeOut(300)
    $('.js-navbar-search-button').removeClass('active')
  }
})

// прелоадер

$(document).ready( function () {
  $('.js-preloader-icon').fadeOut(300, function () {
    $('.js-preloader').fadeOut(300)
  })
})

//инициализация карты
$(function () {
  // $.ajax({
  //   url: 'https://tc.designplanet.ua/json/map',
  //   method: 'GET',
  //   success: function (res) {
  //     console.log(res.cities)
  //     if ( $('.js-map').length ) {
  //       window.Map.resizeContainer()
  //       setTimeout( () => {
  //         window.Map.getData(res.cities)
  //         window.Map.initDefault()
  //       }, 900 )
  //     }
  //   }
  // })

  if ( $('.js-map').length ) {
    window.Map.resizeContainer()
    setTimeout( () => {
      window.Map.getData(cities)
      window.Map.initDefault()
    }, 900 )
  }
})

//табы переключения карты
$('.js-map-tabs-button').on('click', e => {
  e.preventDefault()
  const $target = $(e.currentTarget)
  if ( $target.hasClass('active') ) return;
  $('.js-map-tabs-button').removeClass('active')
  $target.addClass('active')
  window.Map.switchDataSort()
})

// свитчер

$('.js-switcher').each( (i, el) => {
  const $el = $(el)
  const $item = $el.find('.js-switcher-item')
  $item.on('click', e => {
    e.preventDefault()
    if( $(e.currentTarget).hasClass('switcher__item_disabled') ) return;
    $item.removeClass('active')
    $(e.currentTarget).addClass('active')
  })
})

// селекты в фильтре

let feedbackSelect = new Array();

$('.js-filter-select select').each(function (i,e) {
  feedbackSelect[i] = $(e).selectize({
    allowEmptyOption: true
  });
});

// рендер контейнера для отзыва в детализированном рейтинге карточки города

function closeAllFeedbackContainers () {
  $('.js-detail-rating-feedback').slideUp(300, function () {
    const input = this.querySelector('.js-upload-files-input')
    if (input) {
      input.value = ''
      fileList = []
    }
    $(this).empty()
  })
  $('.js-detail-rating-open-feedback').removeClass('active')
}

$(document).on('click', '.js-detail-rating-open-feedback', e => {
  e.preventDefault()
  
  const $target = $( e.currentTarget )
  const $container = $target.parents('.js-detail-rating-item-inner')
  const $feedbackContainer = $container.find('.js-detail-rating-feedback')
  
  if ( $target.hasClass('active') ) {
    return;
  }
  
  closeAllFeedbackContainers()
  $target.addClass('active')
  
  $.ajax({
    url: './data/rating-feedback.html',
    success: (result) => {
      $feedbackContainer.append(result)
      $('.custom-select select').each(function ( i , el ) {
        $(el).selectize()
      })
      $feedbackContainer.slideDown(300)
    }
  })

})

$('.js-detail-rating-feedback').on('click', '.js-rating-feebdack-close', e => { 
  e.preventDefault()
  closeAllFeedbackContainers()
})

// показать или скрыть контейнер ответа в отзывах

$(document).on('click', '.js-feedback-open-button', e => {
  e.preventDefault()
  const $target = $(e.currentTarget)
  const $container = $target.parents('.js-feedback-item')
  const $content = $container.find('.js-feedback-messages')
  $container.addClass('active')
  $content.slideDown(300)
})

$(document).on('click', '.js-feedback-close', e => {
  e.preventDefault()
  const $target = $(e.currentTarget)
  const $container = $target.parents('.js-feedback-item')
  const $content = $container.find('.js-feedback-messages')
  $container.removeClass('active')
  $content.slideUp(300)
})

// апдейт слайдера со списком городов на главной

// $(function () {
//   window.MainCities.destroy()
//   window.MainCities.update()
// })

// отрисовка списка загруженных файлов, хранение, добавление, удаление файлов в массив fileList, обновление списка после удаления

let fileList = [];

$( function () {

  
  $(document).on('change', '.js-upload-files-input', function (e) {
    let files = e.target.files
    const $container = $(this).parents('.js-upload-files')
    const $outputEl  = $container.find('.js-upload-files-list')
    const maxFiles = 5

    for ( let i = 0; i < files.length; i++ ) {
      if ( fileList.length === maxFiles ) break;
      fileList.push(files[i])
    }

    drawList( $outputEl, fileList )
    
  })

  $(document).on('click', '.js-upload-files-remove-file', function (e) {
    e.preventDefault()
    const $outputEl  = $(this).parents('.js-upload-files-list')
    const $elments = $outputEl.find('.js-upload-files-remove-file')
    const index = parseInt($(this).attr('data-remove-index'))
    fileList.splice(index, 1)
    $elments.length === 1 ? $outputEl.empty() :  drawList( $outputEl, fileList )
  })

  function drawList ( container, array ) {
    container.empty()
    container.append('<div class="file-name-title">Загруженные файлы</div>')

    $.each( array, (index, value) => {
      const partial = ' <div class="file-name">' + value.name + '<a class="file-name-close js-upload-files-remove-file" href="#" data-remove-index="' + index + '"></a></div>'
      container.append(partial)
    })
  }

} )

// открыть попап

function openPopupById ( id ) {
  const $target = $(id)
  const $popups = $('.popup')
  $popups.fadeOut(150)
  $popups.removeClass('active')
  $target.fadeIn(100, function () { $(this).css( 'display', 'block') })
  $target.addClass('active')
}

// openPopupById('#service-msg-popup')

// rating feedback url inputs group

$(function () {

  $(document).on( 'click', '.js-input-add-button', e => addInput(e) );

  function addInput (e) {
    e.preventDefault();

    const $target = $(e.currentTarget);
    const $container = $target.parents('.js-rating-feedback-url-group');
    const max = 5;

    if(!$container.length) return;

    const $inputs = $container.find('.js-rating-feedback-url-input');
    const $inputTemplate = $inputs.eq(0).clone().addClass('input_url-added');
    const $currentInput = $target.parents('.js-rating-feedback-url-input');
    
    $inputTemplate.find('.input__field').val('');
    $inputTemplate.find('.js-input-add-button').removeClass('active');

    if ( $target.hasClass('active') ) {
      
      if( $currentInput.index() === 0 ) {
        $currentInput.next().removeClass('input_url-added');
      }

      $currentInput.remove();

      if( $inputs.length === max ) {
        const $inputs = $container.find('.js-rating-feedback-url-input');
        $inputs.last().find('.js-input-add-button').removeClass('active');
      }

    } else {

      if ( $inputs.length === max ) return;

      if ( $inputs.length === max - 1 ) {
        $inputTemplate.find('.js-input-add-button').addClass('active');
      }

      $target.addClass('active');
      $container.append($inputTemplate);
    }

  }

  // hide notification

  function getCookie(name) {
    let matches = document.cookie.match(new RegExp(
      "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }

  if ( !getCookie('hideNotification') ) {
    $('.js-notification').fadeIn(300);
  }

  $(document).on('click', '.js-notification-close', e => {
		$('.js-notification').fadeOut(300);
    const duration = 365 * 24 * 60 * 60 * 1000;
    document.cookie = 'hideNotification=true; max-age=' + duration;
	})

  // hidden text

  $('.js-hidden-text').each((i, el) => {
    const p = $(el).find('p:not(:first-child)')
    p.wrapAll('<div class="hidden-text"></div>')
  })
  
  $(document).on('click', '.js-hidden-text-btn', e => {
    e.preventDefault()
    const parent = $(e.currentTarget).parents('.js-hidden-text')
    const hidden = parent.find('.hidden-text')

    hidden.slideDown(300)
    $(e.currentTarget).fadeOut(100)
  })
})

// announce

$(document).ready( function () {
  
  const listContainer = document.querySelector('.js-events-posts-container')
  
  if (!listContainer) return;
  
  const moreBtn = listContainer.querySelector('.js-more-btn')
  let monthItems = []
  let isDesktop = false
  let isTablet = false
  let isMobile = false
  let firstLoad = true
  
  const options = {
    perPage: 8,
    currentPage: 1,
    lastPage: null,
    total: null
  }
  
  function loadMonthEvents (removeOldEvents) {
    let startDate = listContainer.getAttribute('data-date')
    let endDate
    let date = null
    let lasDayOfMonth = null
    if (!startDate) {
      startDate = null
      endDate = null
    } else {
      date = new Date(startDate)
      lasDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 1).toISOString()
      endDate = lasDayOfMonth.split('T')[0]
    }
    getActiveMonthEvents(startDate, endDate, options.perPage, options.currentPage, removeOldEvents)
  }

  setAdaptiveOptions()

  window.addEventListener('resize', () => {
    setAdaptiveOptions()
  })

  function setAdaptiveOptions () {
    if (window.innerWidth < 1024 && window.innerWidth > 767) {
      if (isTablet) return;
      options.perPage = 6
      options.currentPage = 1
      loadMonthEvents(true)
      
      isDesktop = false
      isTablet = true
      isMobile = false

    } else if (window.innerWidth < 768) {
      if (isMobile) return;
      options.perPage = 3
      options.currentPage = 1
      loadMonthEvents(true)
      
      isDesktop = false
      isTablet = false
      isMobile = true

    } else {
      if (isDesktop) return;
      options.perPage = 8
      options.currentPage = 1
      loadMonthEvents(true)
      
      isDesktop = true
      isTablet = false
      isMobile = false
    }
  }

  function getActiveDayEvents(date, perPage) {
    container.classList.add('is-loading')
    $.ajax({
      url: 'https://tc.designplanet.ua/json/events',
      type: 'GET',
      username: 'admin',
      password: 'bai3pophooR5oaTh',
      contentType: "application/json",
      data: {
        from_at: date,
        to_at: date,
        per_page: perPage
      },
      success: (res) => {
        renderActiveDayEvents(date, res.result.items)
        container.classList.remove('is-loading')
      },
      error: (error) => {
        console.log(error)
      }
    })
  }
  
  function getActiveMonthEvents(at, to, perPage, currentPage, removeOldEvents) {
    listContainer.classList.add('is-loading')
    $.ajax({
      url: 'https://tc.designplanet.ua/json/events',
      type: 'GET',
      username: 'admin',
      password: 'bai3pophooR5oaTh',
      contentType: "application/json",
      data: {
        from_at: at,
        to_at: to,
        per_page: perPage,
        page: currentPage
      },
      success: (res) => {
        const items = res.result.items
        if (!items.length) {
          listContainer.classList.add('hidden')
          return;
        }
        options.total = res.result.total
        options.lastPage = res.result.last_page

        if (options.currentPage == options.lastPage) {
          moreBtn.classList.add('hidden')
        } else {
          moreBtn.classList.remove('hidden')
        }

        if (removeOldEvents) {
          monthItems = []
        }

        items.forEach(el => {
          monthItems.push(el)
        })
        renderActiveMonthEvents(monthItems)
        listContainer.classList.remove('is-loading')
      },
      error: (error) => {
        console.log(error)
      }
    })
  }

  function renderActiveMonthEvents (items) {
    const list = document.querySelector('.js-events-posts')
    
    if (!list || !listContainer) return;
    
    list.innerHTML = ''
    const template = document.querySelector('.js-event-post')

    listContainer.classList.remove('hidden')
    
    items.forEach(el => {
      const $clone = $(template).clone()
      const date = el.date.split(' ')[0]
      const day = date.split('-')[2]
      const month = date.split('-')[1]
      const year = date.split('-')[0].slice(2)
      $clone.removeClass('js-event-post')
      $clone.find('.event-card').attr('href', el.url)
      $clone.find('img').attr('src', el.image)
      $clone.find('.event-card__location').text(el.place)
      $clone.find('.event-card__name').text(el.name)
      $clone.find('.event-card__day').text(day)
      $clone.find('.event-card__date').text(month + '.' + year)
      $clone.appendTo(list)
    })
  }


  moreBtn.addEventListener('click', e => {
    e.preventDefault()

    if (options.currentPage < options.lastPage) {
      options.currentPage++
      loadMonthEvents()
    }
  })
  
  const container = document.querySelector('.js-events')
  if (!container) return;

  const calendar = window.calendar
  let activeDate = null

  function init () {
    container.classList.add('is-loading')
    let at = calendar.startDate
    let to = calendar.endDate
    let monthAt = calendar.monthStartDate
    if (!firstLoad) {
      listContainer.setAttribute('data-date', monthAt)
    }
    let date = new Date().toISOString().split('T')[0]
    monthItems = []
    
    $.ajax({
      url: 'https://tc.designplanet.ua/json/events/stat',
      type: 'GET',
      username: 'admin',
      password: 'bai3pophooR5oaTh',
      contentType: "application/json",
      data: {
        from_at: at,
        to_at: to,
      },
      success: (res) => {
        const result = res.result
        let activeDays = []
  
        result.forEach(el => {
          activeDays.push(el.day_at)
          if (!firstLoad) {

            if (activeDate) {
              calendar.setActiveDay(date)
            } else {

              if (el.day_at === date) {
                calendar.setActiveDay(date)
              }

            }
          } 
        })

        if (firstLoad) {
          date = null
          setActiveDay(date)
        }
        
        calendar.setActiveDays(activeDays)
        container.classList.remove('is-loading')

        firstLoad = false
      },
      error: (error) => {
        console.log(error)
      }
    })
  }

  function setActiveDay (date) {
    if (date) {
      calendar.setActiveDay(date)
    }
    activeDate = date
    getActiveDayEvents(date, 100)
  }

  function renderActiveDayEvents (date, items) {
    const list = container.querySelector('.js-events-list')
    const dateEl = container.querySelector('.js-active-full-date')
    
    if (!date) {
      dateEl.classList.add('hidden')
    } else {
      dateEl.classList.remove('hidden')
    }

    list.innerHTML = ''
    const template = $('.js-active-day-event')
    const emptyTemplate = $('.js-active-day-empty')
    const currentDate = new Date(date)
    dateEl.innerHTML = currentDate.toLocaleString(calendar.langCode, {
      day: '2-digit',
      month: 'long'
    }) + ' ' + currentDate.getFullYear()

    if (!items.length) {
      const $clone = emptyTemplate.clone()
      $clone.appendTo(list)
      return;
    }
    
    items.forEach(el => {
      const $clone = template.clone()
      $clone.removeClass('js-active-day-event')
      $clone.find('.events__post').attr('href', el.url)
      $clone.find('img').attr('src', el.image)
      $clone.find('.events__post-location').text(el.place)
      $clone.find('.events__post-title').text(el.name)
      $clone.find('.events__post-date').text(el.date.split('-').join('.'))
      $clone.appendTo(list)
    })
  }

  $(document).on('click', '.has-events', e => {
    e.preventDefault()
    e.stopImmediatePropagation()
    const target = e.currentTarget
    
    if (target.classList.contains('active')) return;
    
    if (target.classList.contains('js-prev-month')) {
      calendar.setPrevMonth(e)
    }
    
    if (target.classList.contains('js-next-month')) {
      calendar.setNextMonth(e)
    }

    setActiveDay(target.getAttribute('data-date'))
    listContainer.setAttribute('data-date', container.getAttribute('data-date'))
    loadMonthEvents(true)
  })

  container.addEventListener('month-changed', e => {
    e.stopImmediatePropagation()
    init()
  })
 
  init ()

})

